/**
 * The theme uses body scroll lock (body[style*="top"] + [scroll-y-off]) when overlays open.
 * On unlock, `focus()` on the cart trigger in the header can scroll the page before/after
 * the theme's scroll restore — a visible "jump to top, then back". Re-assert the saved Y
 * after the browser and focus handling settle.
 */
(function () {
  'use strict';

  var lockY = 0;
  var nudgeTid = 0;

  function readLockYFromBody() {
    var t = document.body && document.body.style && document.body.style.top;
    if (!t) return;
    var y = Math.abs(parseInt(t, 10) || 0);
    if (y > 0) {
      lockY = y;
    }
  }

  function clearNudges() {
    if (nudgeTid) {
      clearTimeout(nudgeTid);
      nudgeTid = 0;
    }
  }

  function nudgeScrollToSaved() {
    if (lockY < 1) return;
    var y = lockY;
    var cur = window.pageYOffset != null ? window.pageYOffset : window.scrollY;
    if (Math.abs(cur - y) < 3) return;
    window.scrollTo(0, y);
  }

  function scheduleNudges() {
    clearNudges();
    var y = lockY;
    if (y < 1) return;
    nudgeTid = window.setTimeout(function run() {
      nudgeScrollToSaved();
      nudgeTid = window.setTimeout(function () {
        nudgeScrollToSaved();
        nudgeTid = window.setTimeout(nudgeScrollToSaved, 100);
      }, 0);
    }, 0);
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () {
        requestAnimationFrame(nudgeScrollToSaved);
      });
    }
  }

  var bodyMo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].attributeName !== 'scroll-y-off') continue;
      if (document.body.hasAttribute('scroll-y-off')) {
        readLockYFromBody();
        if (window.requestAnimationFrame) {
          requestAnimationFrame(readLockYFromBody);
        }
      } else {
        clearNudges();
        scheduleNudges();
      }
    }
  });

  function boot() {
    if (!document.body) return;
    try {
      bodyMo.observe(document.body, { attributes: true, attributeFilter: ['scroll-y-off'] });
    } catch (e) {}
    if (document.body.hasAttribute('scroll-y-off')) {
      readLockYFromBody();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (window.HTMLElement && window.HTMLElement.prototype) {
    var origFocus = window.HTMLElement.prototype.focus;
    window.HTMLElement.prototype.focus = function (opts) {
      var isCartIcon =
        this.getAttribute && this.getAttribute('data-sidebar-id') === 'CartDrawer' && this.hasAttribute('data-sidebar-button');
      var isCartDrawer = this.id === 'CartDrawer';
      if (isCartIcon || isCartDrawer) {
        try {
          if (!opts) {
            return origFocus.call(this, { preventScroll: true });
          }
          if (typeof opts === 'object' && opts.preventScroll == null) {
            return origFocus.call(
              this,
              Object.assign({}, opts, { preventScroll: true })
            );
          }
        } catch (err) {
          return origFocus.call(this, opts);
        }
      }
      return origFocus.call(this, opts);
    };
  }
})();
